import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backOfficeAdminLink } from "@/components/lib/SidebarLinks";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import ClientDetailsTabs from "./tabs/client-details-tabs";
import { Button } from "@/components/ui/button";
import AssignessTabs from "./tabs/assigned-tabs";
import FollowNotes from "./tabs/follow-notes";
import BusinessLocationTabs from "./tabs/business-location-details";

function QuickSignUp() {
  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backOfficeAdminLink} />}
      pageName={{ title: "Quick Sign Up" }}
      paths={[
        { name: "Back Office", path: "/admin" },
        { name: "Quick Sign Up", path: "/admin/quick-signup" },
      ]}
    >
      <div className="container">
        <div className="flex justify-end items-center gap-3 ">
          <Button className="text-cwhite bg-cred">Cancel</Button>
          <Button className="text-cwhite bg-cgreen">
            Save for Client List
          </Button>
          <Button className="text-cwhite bg-cpink">Save Hot Lead</Button>
          <Button className="text-cwhite bg-cpurple">
            Save as work in-progress
          </Button>
          <Button className="text-cwhite bg-gray1">Send Demo</Button>
        </div>

        <Card className="bg-transparent mt-3 col-span-1 md:col-span-2">
          <Tabs
            className="bg-transparent relative"
            defaultValue="business-location"
          >
            <TabsList className="flex items-start justify-start gap-5 w-full">
              <Separator className="absolute top-8" />
              <TabsTrigger className="bg-transparent" value="client-details">
                Client Details
              </TabsTrigger>
              <TabsTrigger value="assignees">Assignees</TabsTrigger>
              <TabsTrigger value="followup-notes">
                Follow up & Notes
              </TabsTrigger>
              <TabsTrigger value="business-location">
                Business & location Details
              </TabsTrigger>
              <TabsTrigger value="outlet-requirements">
                Outlet & requirements
              </TabsTrigger>
              <TabsTrigger value="invoice">Invoice</TabsTrigger>
              <TabsTrigger value="agreement">Agreement</TabsTrigger>
            </TabsList>
            <ClientDetailsTabs />
            <AssignessTabs />
            <FollowNotes />
            <BusinessLocationTabs />
            {/* Add other tabs content here */}
          </Tabs>
        </Card>
      </div>
    </Layout2>
  );
}

export default QuickSignUp;
